const quotes = [
    "<strong>SLA</strong> keeps us looking our very best<br/>at every tradeshow we attend.",
    "<strong>SLA</strong> is an amazing extension of our team -<br/>a truly valued partner.",
    "<strong>SLA</strong> knows exactly what is needed and always<br/> provides the most cost effective solution."
];

export default quotes;


// WEBPACK FOOTER //
// ./src/components/Quote/quotes.js